/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { jsx, cssMap as unboundedCssMap } from '@compiled/react';

import { token } from '@atlaskit/tokens';

export enum FontVariant {
	HeadingMedium = 'headingMedium',
	HeadingSmall = 'headingSmall',
	HeadingXSmall = 'headingXSmall',
	Body = 'body',
	BodyLarge = 'bodyLarge',
}

type TextElementProps = {
	children: React.ReactNode;
	fontVariant: FontVariant;
	maxLine: number;
};

const unboundedStyles = unboundedCssMap({
	baseText: {
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		display: '-webkit-box',
		WebkitBoxOrient: 'vertical',
		WebkitLineClamp: '3', // Default to 3 lines
	},
	title: {
		// small card title needs width explicitly set to 100%
		width: '100%',
	},
	description: {
		whiteSpace: 'normal',
	},
	headingMedium: {
		font: token('font.heading.medium'),
	},
	headingSmall: {
		font: token('font.heading.small'),
	},
	headingXSmall: {
		font: token('font.heading.xsmall'),
	},
	bodyLarge: {
		font: token('font.body.large'),
	},
	body: {
		font: token('font.body'),
	},
});

export const CardTitle = ({ children, maxLine, fontVariant }: TextElementProps): JSX.Element => (
	<span
		css={[unboundedStyles.baseText, unboundedStyles.title, unboundedStyles[fontVariant]]}
		style={{
			WebkitLineClamp: maxLine,
		}}
	>
		{children}
	</span>
);

export const CardDescription = ({
	children,
	maxLine,
	fontVariant,
}: TextElementProps): JSX.Element => (
	<span
		css={[unboundedStyles.baseText, unboundedStyles.description, unboundedStyles[fontVariant]]}
		style={{
			WebkitLineClamp: maxLine,
		}}
	>
		{children}
	</span>
);
